import Phaser from "phaser";

/**
 * Arranque. En FASE 3 no hay assets que precargar (arte procedural),
 * así que solo encadena a la escena jugable. Aquí irá la carga de
 * assets por escena (punto 38) cuando existan sprites.
 */
export class BootScene extends Phaser.Scene {
  constructor() {
    super("boot");
  }

  create(): void {
    this.scene.start("city");
  }
}
